export default __webpack_public_path__ + "static/media/kid22.83f54e61.jpg";